import React, { useContext, useCallback } from 'react';
import {} from 'react-icons/fi';
import { PageContext } from '../context';
import { ContentWrapper } from '../styles';
import { LPText } from '../../styles';

import BrandFooter from './BrandFooter';

import RadioBtn from '../../../components/RadioBtn';

const BookingGuests = () => {
  const context = useContext(PageContext);
  const {
    questions,
    questionsData,
    isQuestionsFormValid,
    setQuestionAnswer,
    validationQuestionErrors,
  } = context;

  const handleChange = useCallback(
    (name, value) => {
      setQuestionAnswer(name, value);
    },
    [setQuestionAnswer],
  );

  const getErrorMessages = (name) => {
    const messages = [];
    validationQuestionErrors.forEach((e) => {
      if (e.path === name && questionsData[name]) {
        messages.push(e.message);
      }
    });
    return messages;
  };

  return (
    <>
      <ContentWrapper>
        <LPText padded w800>
          Please complete the COVID-19 self assessment questionnaire 😷🙏.
        </LPText>
        {questions.map(({ label, options, name }) => (
          <>
            <RadioBtn
              key={name}
              label={label}
              name={name}
              value={questionsData[name]}
              items={options}
              onChange={(e) => handleChange(name, e.target.value)}
              errors={getErrorMessages(name)}
            />
          </>
        ))}
      </ContentWrapper>
      <BrandFooter disabled={!isQuestionsFormValid} />
    </>
  );
};

BookingGuests.propTypes = {};

export default BookingGuests;
